import { SxProps } from '@mui/material';

export const maxLinesSx = (maxNumberOfLines: number): SxProps => ({
  display: '-webkit-box',
  WebkitLineClamp: `${maxNumberOfLines}`,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});
